import React from "react";
import secureLocalStorage from "react-secure-storage";//Added By Shreyas for Local Storage Security.
import {tokencallurl,GETUIDRESPONSE} from './constants/APIConstants';
import axios from 'axios';
import { Buffer } from 'buffer'
import Loading from './UIDLoader';
export function toBase64(input) {  return Buffer.from(input, 'utf-8').toString('base64')}
export function fromBase64(encoded) {  return Buffer.from(encoded, 'base64').toString('utf8')}


class CallBack extends React.Component{

    componentDidMount()
    {
        let urltkn;
        urltkn = tokencallurl;
        this.setState({loading: true})
        const queryParameters = new URLSearchParams(window.location.search)
        const Code = queryParameters.get("code")
        
        var access_token="";
axios.get(`${process.env.REACT_APP_API}/proxy/get?input=/LogIn/VerifyLogin` )
      .then((res) => {
        const encodedval =res.data.split(':')[0];
        const HpCookie=res.data.split(':')[1];
var config = {
          method: 'get',
          url: `${process.env.REACT_APP_API}/proxy/get?input=/LogIn/GenerateClientToken/`+ Code,
          headers: { 
            //'Authorization': 'Basic '+ encodedval, 
            //'Content-Type': 'application/x-www-form-urlencoded', 
            //'Cookie': HpCookie
          },
        };

        axios(config)
        .then(function (response) {  
          var obj=JSON.stringify(response.data);
          let access_token_data = JSON.parse(obj);
          access_token=access_token_data.access_token;   
        })
        .catch(function (error) {   
          console.log(error);
     }).finally(() => {      
            const content = { text: access_token };
            let url;
            url = GETUIDRESPONSE();
            axios.post(url,content, {
            })
              .then((res) => {
                this.setState({ data: res.data.Body })
                if(res.data==="UID_Failed")
                {                     
                    secureLocalStorage.setItem("loggeduser",res.data); 
                    window.location.href = "/";
                }
                else
                {
                  secureLocalStorage.setItem("loggeduser",res.data);
                  this.setState({ User: res.data });             
                  window.location.href = "/?Code="+res.data;

                }
                this.setState({ loading: false });
              }
              , (error) =>
              {
                console.log(error);                    
              }) 
      });

      }, (error) => {
        this.setState({ data: null, countryLoading: false })
      })
    }
    render(){

return(
  <React.Fragment>
  <Loading loading={Loading} ></Loading>
  <div>
            <br />
            
            <div  className="row vh-100">
              <div className="col-sm-6">
              </div>
              <div className="col-sm-6">
               
                </div></div></div>
  
  
  </React.Fragment>
);
    }
}
export default CallBack;